import { render, staticRenderFns } from "./LeadBoardCreateQuestionnaireSidebar.vue?vue&type=template&id=22832912&"
import script from "./LeadBoardCreateQuestionnaireSidebar.vue?vue&type=script&lang=js&"
export * from "./LeadBoardCreateQuestionnaireSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports